import React from 'react';
import { useSelector } from 'react-redux';
import { Flex } from '@chakra-ui/react';

import { getTabSelectOptions } from '../../../../../../constants/tabMenuTypes';
import RequirementTemplateBlueprintType from '../../../../../../types/RequirementTemplateBlueprintType';
import { HorizontalTabs, HTab } from '../../../../../HorizontalTabs';
import { horizontalTabContentBoxStyles } from '../../../../util/options';

const RequirementTemplateBuilderBodyLeft = ({ blueprint }) => {
  const currentTabIdLeft = useSelector(blueprint.selectDefaultTemplateTabIdLeft);
  const tabTypeOption = useSelector(blueprint.selectLeftTabTypeOption);
  const horizontalTabs = getTabSelectOptions(tabTypeOption);
  const sidePanelHeight = useSelector(blueprint.selectSidePanelHeight);

  return (
    <Flex
      align="center"
      h="93%"
      justifyContent="flex-start"
      minH="75vh"
      minW="380px"
      mt={5}
      w="380px"
    >
      {horizontalTabs && (
      <HorizontalTabs
        center
        contentBoxStyles={{ ...horizontalTabContentBoxStyles, height: sidePanelHeight }}
        defaultTabId={currentTabIdLeft}
        tabGroupWidth="200px"
      >
        {horizontalTabs.map(option => (
          <HTab {...option} key={option.tabId} />
        ))}
      </HorizontalTabs>
      )}
    </Flex>
  );
};

RequirementTemplateBuilderBodyLeft.propTypes = { blueprint: RequirementTemplateBlueprintType };

export default RequirementTemplateBuilderBodyLeft;
